var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"content-wrapper"},[_c('HeaderRegistered',{attrs:{"title":_vm.title}}),_c('main',{staticClass:"main"},[_c('section',{staticClass:"dashboard-section"},[_c('ManageKeys')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }